const config = {
    admin_path: process.env.REACT_APP_ADMIN_PATH,
    api_key: process.env.REACT_APP_API_KEY,
    api_path: process.env.REACT_APP_API_PATH,
    api_profile: process.env.REACT_APP_API_PROFILE,
    api_statics: process.env.REACT_APP_API_STATICS,
};

export default config;
